import axios from 'axios'
import store from './../store';

export default class PayoutService {


    async generateAll(token) {
        try {
            const res = await axios({
                method: 'post',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/generate',
                headers: {
                    authorization: token
                }
            });
            return res;
        }
        catch (error) {
            throw new Error(error)
        }
    }


    async turnoverPayouts(token,end_date) {
        try {

            var start_date = addDays(end_date, -7);
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/turnover/' + start_date.toISOString() + '/' + end_date.toISOString(),
                headers: {
                    authorization: token
                }
            });

            return res.data;
        }
        catch (error) {
            throw new Error(error)
        }
    }


    async convertPending(token) {
        try {
            const res = await axios({
                method: 'put',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/convert/pending',
                headers: {
                    authorization: token
                }
            });
            return res;
        }
        catch (error) {
            throw new Error(error)
        }
    }
    async listPayouts(id, token, end_date) {
        try {
            
            var start_date = addDays(end_date, -7);
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/list/' + id+'/'+start_date.toISOString()+'/'+end_date.toISOString(),
                headers: {
                    authorization: token,

                }

            });

            return res.data;
        }
        catch (error) {
            throw new Error(error)
        }
    }



    async sumPayouts(id, status, token) {
        try {
            const res = await axios({
                method: 'get',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/sum/' + id + '/' + status,
                headers: {
                    authorization: token
                }
            });

            return res.data[0].amount;
        }
        catch (error) {
            throw new Error(error)
        }
    }

    async removePayout(id, token) {
        try {
            const res = await axios({
                method: 'delete',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/remove/' + id,
                headers: {
                    authorization: token
                }
            });

            return res;
        }
        catch (error) {
            throw new Error(error)
        }
    }
    async approvePayout(id, token) {
        try {
            const res = await axios({
                method: 'put',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/approve/' + id,
                headers: {
                    authorization: token
                }
            });

            return res;
        }
        catch (error) {
            throw new Error(error)
        }
    }

    async changeType(id, type) {
        try {
            const res = await axios({
                method: 'put',
                url: process.env.VUE_APP_AUTH_URL + 'api/v1/payouts/changetype/' + id+'/'+type,
                headers: {
                    authorization: store.state.currentUser.token
                }
            });

            return res;
        }
        catch (error) {
            throw new Error(error)
        }
    }


}

function addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}